import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { AgentsPage } from './_dashboard.devices.agents'

export const Route = createFileRoute('/_dashboard/devices/agents/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: AgentsIndexPage,
})

function AgentsIndexPage() {
  return <AgentsPage selectedId={undefined} />
}
